import './CakeOrderCard.css'
import React from 'react';
import { formatDateInSpanish } from '../../../helpers/general.js';
import service from '../../../services/cakeorders.service.js';
import { sendSmsCakeReady } from '../../../helpers/cakes.js';

export default function CakeOrderCard({ order }) {

    async function onToggleReadiness(orderId, ready) {
        service.toggleReadiness(orderId, ready);
        try {
            if (!order.ready) await sendSmsCakeReady(order);
        } catch (error) {
            console.error("Mensaje al cliente NO fue enviado.", error);
            alert("Mensaje al cliente NO fue enviado.", error.message);
        }
    }

    // Helper function to format fillings
    const formatFillings = (filling1, filling2) => {
        const fillings = [];
        if (filling1 && filling1.trim()) fillings.push(filling1.trim());
        if (filling2 && filling2.trim()) fillings.push(filling2.trim());
        return fillings.length > 0 ? fillings.join(' • ') : 'Sin relleno';
    };

    return (
        <div className={`cake-order-card ${order.ready ? 'ready' : 'pending'}`}>
            {/* Header Section */}
            <div className="card-header">
                <h2 className="customer-name">{order.firstName} {order.lastName}</h2>
                <div className="status-badge">
                    {order.ready ? '✅ LISTO' : '⏳ PENDIENTE'}
                </div>
            </div>

            {/* Order Details Table */}
            <table className="order-table">
                <tbody>
                    <tr>
                        <th>📅 Fecha</th>
                        <td>{formatDateInSpanish(order.date)}</td>
                    </tr>
                    <tr>
                        <th>🕐 Hora</th>
                        <td>{order.time}</td>
                    </tr>
                    <tr>
                        <th>📏 Tamaño</th>
                        <td>{order.cakeSize}</td>
                    </tr>
                    <tr>
                        <th>🎨 Color</th>
                        <td>{order.color}</td>
                    </tr>
                    <tr>
                        <th>🍰 Rellenos</th>
                        <td>
                            <div className="fillings-container">
                                {formatFillings(order.filling1, order.filling2).split(' • ').map((filling, index) => (
                                    <span key={index} className="filling-tag">{filling}</span>
                                ))}
                            </div>
                        </td>
                    </tr>
                    {order.message && (
                        <tr>
                            <th>💝 Dedicatoria</th>
                            <td className="message-text">{order.message}</td>
                        </tr>
                    )}
                    {order.comments && order.comments.trim() !== '' && (
                        <tr>
                            <th>📝 Comentarios</th>
                            <td className="comments-text">{order.comments}</td>
                        </tr>
                    )}
                    <tr>
                        <th>👤 Cajer@</th>
                        <td>{order.cashier}</td>
                    </tr>
                </tbody>
            </table>

            {/* Image Section */}
            {order.imageUrl && (
                <div className="image-section">
                    <span className="label">📸 Imagen de referencia</span>
                    <img src={order.imageUrl} alt="Pastel de referencia" className="cake-image" />
                </div>
            )}

            {/* Action Button */}
            <div className="action-section">
                <button 
                    className={`toggle-button ${order.ready ? 'ready' : 'pending'}`}
                    onClick={() => onToggleReadiness(order.id, order.ready)}
                >
                    {order.ready ? '⬅️ Mover a Pendientes' : '✅ Marcar como Listo'}
                </button>
            </div>
        </div>
    );
}